import { offset } from '../../../../../../utils/dom'

import {
  changeMode,
  MODE_TYPES,
  MODE,
  getCurClient,
  getReferNode,
  isDom
} from './shared'

import createBar from './bar'

// 当前配置
const BAR_MAP = {
  vertical: {
    OFFSETSIZE: 'offsetHeight',
    scroll: 'scrollTop',
    SCROLLSIZE: 'scrollHeight',
    size: 'height',
    key: 'vertical',
    axis: 'Y',
    client: 'clientY',
    direction: 'top'
  },
  horizontal: {
    OFFSETSIZE: 'offsetWidth',
    scroll: 'scrollLeft',
    SCROLLSIZE: 'scrollWidth',
    size: 'width',
    key: 'horizontal',
    axis: 'X',
    client: 'clientX',
    directionX: 'left',
    directionY: 'bottom',
    assistDirection: 'top',
    assistSize: 'height'
  }
}

// 绑定初始化
function _init (options) {
  changeMode(MODE_TYPES.WAIT)
  const { $el, refer, BAR_CONFIG } = options
  let $elBar = null // 当前滚动条
  let referNode = null // 外层盒dom

  let visibilityRegion // 开始区域大小

  if (referNode === null) {
    referNode = getReferNode($el, refer)
  }

  const {
    directionX,
    directionY,
    OFFSETSIZE,
    SCROLLSIZE,
    key: BARKEY,
    scroll: SCROLL,
    axis,
    assistSize,
    assistDirection
  } = BAR_CONFIG

  // 计算当前滚动条的位置
  function computed () {
    if (!$elBar) return
    const { [assistSize]: size } = referNode.getBoundingClientRect()
    const { [directionX]: direction, [assistDirection]: elPos } = offset(
      referNode
    )
    const {
      [assistDirection]: scrollPos
    } = document.body.getBoundingClientRect()
    /* 计算滚动条位置 */
    if (
      visibilityRegion &&
      elPos + size > visibilityRegion[assistSize] - scrollPos
    ) {
      $elBar.style.position = 'fixed'
      $elBar.style[directionY] = 0
      $elBar.style[directionX] = `${direction}px`
    } else {
      $elBar.style.position = ``
      $elBar.style[directionY] = ``
      $elBar.style[directionX] = ``
    }
  }

  // 事件管理
  const EVENTFN = {
    handleMouseenter () {
      visibilityRegion = getCurClient()
      const { [OFFSETSIZE]: offsetSize, [SCROLLSIZE]: scrollSize } = $el
      if (offset >= scrollSize) {
        return
      }
      if ($elBar === null) {
        $elBar = createBar(referNode, BARKEY, $el, BAR_CONFIG)
      }
      computed()
      /* 更新宽度 */
      $elBar.firstChild.style.width = `${(offsetSize / scrollSize) * 100}%`
      $elBar.style.width = `${offsetSize}px`
      changeMode(
        MODE === MODE_TYPES.DOWN ? MODE_TYPES.SHOW_DOWN : MODE_TYPES.SHOW
      )
      $elBar.changeScrollState('visible')
    },
    handleMouseleave () {
      if (MODE === MODE_TYPES.SHOW) {
        changeMode(MODE_TYPES.WAIT)
        $elBar.changeScrollState()
        return
      }
      changeMode(MODE_TYPES.DOWN)
    },
    handleScroll (event) {
      if (event.target === $el) {
        const dom = $elBar?.firstChild
        const { [OFFSETSIZE]: offsetSize, [SCROLL]: scroll } = event.target
        if (dom) {
          dom.style.transform = `translate${axis}(${(scroll * 100) / offsetSize}%)`
          dom.style['msTransform'] = `translate${axis}(${(scroll * 100) / offsetSize}%)`
        }         
      }
      options.onScroll && options.onScroll(event)
    },
    // 当前模式为show时滚动同步滚动条位置
    hanldeWindowScroll () {
      MODE === 'SHOW' && computed()
    },
    handleWindowResize () {
      EVENTFN.handleMouseenter()
    }
  }

  function bindEvent () {
    $el.addEventListener('scroll', EVENTFN.handleScroll)
    referNode.addEventListener('mouseenter', EVENTFN.handleMouseenter)
    referNode.addEventListener('mouseleave', EVENTFN.handleMouseleave)
    document.addEventListener('scroll', EVENTFN.hanldeWindowScroll, true)
    // EVENTFN.handleWindowResize = debounce(EVENTFN.handleWindowResize, 150)
    document.addEventListener('resize', EVENTFN.handleWindowResize)
  }

  function destroyedEvent () {
    // 组件销毁时删除dom
    $elBar && referNode.removeChild($elBar)
    $el.addEventListener('scroll', EVENTFN.handleScroll)
    referNode.removeEventListener('mouseenter', EVENTFN.handleMouseenter)
    referNode.removeEventListener('mouseleave', EVENTFN.handleMouseleave)
    document.removeEventListener('scroll', EVENTFN.hanldeWindowScroll)
    document.removeEventListener('resize', EVENTFN.handleWindowResize)
  }

  return {
    bindEvent,
    destroyedEvent
  }
}

export default class ScrollBar {
  constructor (el, options = { type: 'horizontal' }) {
    if (!isDom(el)) {
      throw new Error('params error: el is required')
    }
    this.$el = el
    this.$options = options
    this.$options.$el = el
    const BAR_CONFIG = BAR_MAP[options.type]
    this.init({ ...this.$options, BAR_CONFIG })
  }

  init (options) {
    const { bindEvent, destroyedEvent } = _init(options)
    this.destroyed = destroyedEvent
    bindEvent.call(this)
  }
}
